"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HISTORY_SNAPSHOT_INTERVAL_MS = exports.HISTORY_SNAPSHOT_INTERVAL_SECONDS = void 0;
exports.historySnapshotWindowIndex = historySnapshotWindowIndex;
exports.historySnapshotWindowStartMs = historySnapshotWindowStartMs;
/** Cross-runtime SSOT for logical document-history snapshot windows. */
exports.HISTORY_SNAPSHOT_INTERVAL_SECONDS = 600;
exports.HISTORY_SNAPSHOT_INTERVAL_MS = exports.HISTORY_SNAPSHOT_INTERVAL_SECONDS * 1000;
function historySnapshotWindowIndex(timestampMs) {
    return Math.floor(timestampMs / exports.HISTORY_SNAPSHOT_INTERVAL_MS);
}
function historySnapshotWindowStartMs(timestampMs) {
    return historySnapshotWindowIndex(timestampMs) * exports.HISTORY_SNAPSHOT_INTERVAL_MS;
}
